// extracted by mini-css-extract-plugin
module.exports = {"paper":"Form_paper__elCVy","formcss":"Form_formcss__3bMSL","fileInput":"Form_fileInput__6Uw6V","buttonSubmit":"Form_buttonSubmit__1oT7g"};